export default {
  addProcess (state, payload) {
    let processes = Object.assign({}, state.processes)
    processes[payload.process] = {
      inProcess: true
    }
    if (payload.message) processes[payload.process].message = payload.message
    state.processes = processes
  },
  deleteProcess (state, process) {
    let processes = Object.assign({}, state.processes)
    if (processes[process]) delete processes[process]
    state.processes = processes
  }
}
